;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["totalPages", "currentPage"],
  name: "TaskPaginate",
  computed: {
    pagination: function pagination() {
      var maxVisiblePages = 10;
      var pages = [];
      if (this.totalPages <= maxVisiblePages) {
        for (var i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        var halfMaxVisible = Math.floor(maxVisiblePages / 2);
        var startPage = this.currentPage - halfMaxVisible;
        var endPage = this.currentPage + halfMaxVisible;

        if (startPage < 1) {
          startPage = 1;
          endPage = maxVisiblePages;
        }

        if (endPage > this.totalPages) {
          endPage = this.totalPages;
          startPage = this.totalPages - maxVisiblePages + 1;
        }

        if (startPage > 1) {
          pages.push(1);
        }

        if (startPage > 2) {
          pages.push("...");
        }

        for (var _i = startPage; _i <= endPage; _i++) {
          pages.push(_i);
        }

        if (endPage < this.totalPages - 1) {
          pages.push("...");
        }

        if (endPage < this.totalPages) {
          pages.push(this.totalPages);
        }
      }
      return pages;
    }
  },
  methods: {
    goToPage: function goToPage(page) {
      if (page !== "...") {
        this.$emit("pageChanged", page);
      }
    },
    prevPage: function prevPage() {
      if (this.currentPage > 1) {
        this.goToPage(this.currentPage - 1);
      }
    },
    nextPage: function nextPage() {
      if (this.currentPage < this.totalPages) {
        this.goToPage(this.currentPage + 1);
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('nav',{attrs:{"aria-label":"Page navigation example"}},[_c('ul',{staticClass:"pagination justify-content-center"},[_c('li',{staticClass:"page-item",class:{ disabled: _vm.currentPage === 1 }},[_c('a',{staticClass:"page-link",attrs:{"href":"#","tabindex":"-1"},on:{"click":_vm.prevPage}},[_vm._v("Previous")])]),_vm._v(" "),_vm._l((_vm.pagination),function(page){return _c('li',{key:page,staticClass:"page-item",class:{ 'active': _vm.currentPage === page }},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.goToPage(page)}}},[_vm._v(_vm._s(page))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ disabled: _vm.currentPage === _vm.totalPages || _vm.totalPages <= 1 }},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":_vm.nextPage}},[_vm._v("Next")])])],2)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2381dd5d", __vue__options__)
  } else {
    hotAPI.reload("data-v-2381dd5d", __vue__options__)
  }
})()}